import { Pagination } from '@innovyze/shared-utils';
import { ContentCard, rem, StylovyzeTableFooter } from '@innovyze/stylovyze';
import { getValue } from '@Selectors';
import { ROWS_PER_PAGE } from '@Types/pagination.types';
import { SensorGroupsSearchProps } from '@Types/sensorGroup.types';
import React from 'react';
import { useSelector } from 'react-redux';
import SensorGroupsTableBody from './SensorGroupsTableBody';
import SensorGroupsTableHeader from './SensorGroupsTableHeader';

interface SensorGroupsTableProps {
	searchProps: SensorGroupsSearchProps;
	setSearchProps: React.Dispatch<
		React.SetStateAction<SensorGroupsSearchProps>
	>;
}

const SensorGroupsTable = ({
	searchProps,
	setSearchProps,
}: SensorGroupsTableProps) => {
	const { pagination } = useSelector(getValue).sensorGroup.sensorGroups;
	const { current = 0, pages = 1 } = pagination || ({} as Pagination);

	const header = (
		<SensorGroupsTableHeader
			setSearchProps={setSearchProps}
			searchProps={searchProps}
		/>
	);

	const footer = (
		<StylovyzeTableFooter
			rowsPerPage={{
				options: ROWS_PER_PAGE.map(name => ({
					name: name.toString(),
					onClick: () => {
						setSearchProps(prevSearchParams => ({
							...prevSearchParams,
							limit: name,
							offset: 0,
						}));
					},
				})),
				selectedIndex: 1,
			}}
			pagination={{
				totalNumberOfPages: pages,
				currentPage: current + 1,
				dataCy: 'sensor-group-pagination',
				onChange: (_e, page) => {
					setSearchProps({
						...searchProps,
						offset: page - 1,
					});
				},
			}}
		/>
	);

	return (
		<ContentCard
			header={header}
			footer={footer}
			applyBodyPadding={false}
			minHeight={rem(600)}>
			<SensorGroupsTableBody
				searchParams={searchProps}
				setSearchParams={setSearchProps}
			/>
		</ContentCard>
	);
};
export default SensorGroupsTable;
